<div>
  <input type="number"
        [formControl]="numberPercentageDirtyFormControl"
        class="form-control"
        autocomplete="off"
        [formlyAttributes]="field"
        [class.is-invalid]="showError">
  <span>%</span>
</div>
